import { render, staticRenderFns } from "./BannerWidget.vue?vue&type=template&id=623a870a&"
import script from "./BannerWidget.vue?vue&type=script&lang=js&"
export * from "./BannerWidget.vue?vue&type=script&lang=js&"
import style0 from "./BannerWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports